"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _getEnvironmentFromHost = require("./getEnvironmentFromHost");
Object.keys(_getEnvironmentFromHost).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _getEnvironmentFromHost[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _getEnvironmentFromHost[key];
    }
  });
});
